/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    COOKIE_AUTH_REQUIRE_ADMIN_FIX
 * Date:         2026-02-12
 * Modified By:  Claude
 *
 * Description:
 * Fixed RequireAdmin to use cookie-based auth (checkAuthStatus) instead of
 * deprecated getUserInfoFromToken (localStorage). After the 2026-02-11 cookie-auth
 * migration, admin users were being redirected to "/" because localStorage token
 * was empty.
 *
 * Related Files:
 * - client/src/utils/authUtils.ts (checkAuthStatus)
 * - client/src/App.tsx (uses same checkAuthStatus pattern)
 */

import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkAuthStatus } from "../../utils/authUtils";

export default function RequireAdmin({ children }: { children: JSX.Element }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAuthStatus().then((userInfo) => {
      setIsAdmin(!!userInfo?.isAdmin);
      setIsChecking(false);
    });
  }, []);

  if (isChecking) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
